import React, { memo, useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { EVENT, SELECT_FILTER_SPECIALITY } from '../../../TrackerFolder/constants/ActionType';
import { onSelectSpeciality, trackEvent } from '../../../TrackerFolder/actions';
import { Skeleton } from '@mui/material';
import { FaFilter } from '../../icons';
import { useTracker } from '../../../TrackerFolder/TrackerComponent';
import { getLocalStorage, isEligibleForSpeciality } from '../../../common/common';
import { useSearchParams } from 'react-router-dom';
import { useSpecialityList } from '../../../Queries/QueryHooks/common.hook';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import '../../../assets/sass/uiV3/component/_filterBar.scss';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import { isMobile } from 'react-device-detect';
dayjs.extend(customParseFormat);

function FilterBar({
  topClass,
  showVideoFilter = false,
  showDateRange = false,
  showSessionType = false
}) {
  var { data: specialities, isLoading: specialitiesLoading } = useSpecialityList();

  const { trackActivityEvent } = useTracker();
  const isSpecialityEligible = isEligibleForSpeciality(getLocalStorage('user', '{}'));
  const [searchParams, setSearchParams] = useSearchParams();
  const [show, setShow] = useState(false);

  const showVideo = searchParams.get('type') === 'video' ? true : false;
  const selectedSpecialities = searchParams.has('specialities')
    ? searchParams.get('specialities').split(',')
    : [];

  function onChangeTrigger(spec, index) {
    trackActivityEvent(SELECT_FILTER_SPECIALITY, onSelectSpeciality(spec.specialities_name));

    const temp = [...selectedSpecialities];

    if (temp.includes(spec.master_specialities_id)) {
      temp.splice(temp.indexOf(spec.master_specialities_id), 1);
      if (temp.length > 0)
        setSearchParams((prev) => {
          prev.set('specialities', temp.toString());
          return prev;
        });
      else {
        setSearchParams((prev) => {
          prev.delete('specialities');
          return prev;
        });
      }
    } else {
      temp.push(spec.master_specialities_id);
      setSearchParams((prev) => {
        prev.set('specialities', temp.toString());
        return prev;
      });
    }
  }

  function onChangeVideo(state) {
    trackActivityEvent(EVENT, trackEvent('CHANGE_VIDEO_FLAG'));

    if (state) {
      setSearchParams((prev) => {
        prev.set('type', 'video');
        return prev;
      });
    } else {
      setSearchParams((prev) => {
        prev.delete('type');
        return prev;
      });
    }
    // change_video_flag();
  }

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
    trackActivityEvent(EVENT, trackEvent('CLICK_FILTER'));
  };

  const handleStartDate = (data) => {
    if (data) {
      setSearchParams((prev) => {
        prev.set('dateFrom', dayjs(data)?.format('DD-MM-YYYY'));
        return prev;
      });
    } else {
      setSearchParams((prev) => {
        prev.delete('dateFrom');
        return prev;
      });
    }
  };

  const handleEndDate = (data) => {
    if (data) {
      setSearchParams((prev) => {
        prev.set('dateTo', dayjs(data)?.format('DD-MM-YYYY'));
        return prev;
      });
    } else {
      setSearchParams((prev) => {
        prev.delete('dateTo');
        return prev;
      });
    }
  };

  return (
    <>
      {isMobile ? (
        <a
          href="javascript:void(0)"
          className="rounded-circle filterBarMobile rippleEffect d-flex justify-content-center align-items-center position-fixed bg-primary text-white gtm_cl_medwiki_listing_filter"
          onClick={() => setShow(true)}
        >
          <FaFilter customClass="fs-2" gtmTagVariable="gtm_cl_medwiki_listing_filter" />
          {selectedSpecialities?.length != 0 ? (
            <span className="rounded-circle bg-white position-absolute p-1 d-flex justify-content-center align-items-center fs-2 gtm_cl_medwiki_listing_filter text-primary">
              {selectedSpecialities?.length == 0 ? null : selectedSpecialities?.length}
            </span>
          ) : null}
        </a>
      ) : (
        <div
          className={`filterBar d-flex bg-white shadow position-relative overflow-hidden mb-20 ${
            topClass
              ? !isSpecialityEligible
                ? 'filterBarScroll--V2 filterBarScroll'
                : 'filterBarScroll'
              : ''
          } `}
          style={{
            top:
              topClass && isSpecialityEligible
                ? document.querySelector('.topHeader').clientHeight
                : ''
          }}
        >
          {showVideoFilter ? (
            <div className="filterBarLeft flex-shrink-0 d-flex align-items-center justify-content-center">
              <Form>
                <Form.Check
                  className="fs-16 fw-medium position-relative text-start m-0 gtm_cl_medwiki_listing_videos_only"
                  type="switch"
                  label="Videos Only"
                  onChange={(e) => onChangeVideo(e.target.checked)}
                  checked={showVideo}
                />
              </Form>
            </div>
          ) : (
            <></>
          )}
          <div className="filterBarRight flex-grow-1 position-relative border-start border-light ps-3 d-flex">
            <div className="h-100 overflow-x-auto flex-grow-1">
              <div className="filterBarSpec h-100 d-flex align-items-center position-relative ">
                {!specialitiesLoading
                  ? specialities?.length > 0 &&
                    specialities?.map((spec, index) => {
                      if (selectedSpecialities.length > 0) {
                        if (selectedSpecialities.includes(spec.master_specialities_id))
                          return (
                            <Form.Check
                              key={spec.master_specialities_id}
                              inline
                              type="checkbox"
                              className="position-relative p-0 me-2 gtm_cl_medwiki_listing_filter_specialities"
                              label={spec.specialities_name}
                              checked={selectedSpecialities?.includes(spec.master_specialities_id)}
                              onChange={() => onChangeTrigger(spec, index)}
                            />
                          );
                        else return null;
                      } else
                        return (
                          <Form.Check
                            key={spec.master_specialities_id}
                            inline
                            type="checkbox"
                            className="position-relative p-0 me-2 gtm_cl_medwiki_listing_filter_specialities"
                            label={spec.specialities_name}
                            onChange={() => onChangeTrigger(spec, index)}
                          />
                        );
                    })
                  : [...Array(6).keys()].map((_i, index) => (
                      <Skeleton
                        key={index + 1}
                        variant="rectangular"
                        width={100}
                        height={30}
                        style={{ borderRadius: '20px' }}
                      />
                    ))}
              </div>
            </div>
            <span
              className="fs-16 ms-3 filterBarIcon rippleEffect cursorPointer flex-shrink-0 bg-primary text-white d-flex justify-content-center align-items-center gap-3 px-20 gtm_cl_medwiki_listing_filter"
              onClick={() => handleShow()}
            >
              <FaFilter customClass="fs-2 " />
              Filter
            </span>
          </div>
        </div>
      )}

      <Modal className="rightModal filterBarModal" size="sm" show={show} onHide={handleClose}>
        <Modal.Header className="bg-primary">
          <Modal.Title className="text-white fs-3">Apply Filter</Modal.Title>
          <span
            className="modalClose rounded-circle cursorPointer text-white gtm_cl_medwiki_listing_filter_ok fs-3"
            onClick={handleClose}
          >
            Ok
          </span>
        </Modal.Header>
        <Modal.Body>
          {showDateRange && (
            <div>
              <h2 className="border-bottom text-black fw-medium fs-16 mb-4 pb-3">
                Select Date Range
              </h2>
              <div className="d-inline-flex align-items-center ssnFilterDateCont">
                <DatePicker
                  popperPlacement="top-end"
                  className="fs-4 fw-medium rounded ssnFltrCalenderInp px-4 py-0 border border-light"
                  selected={
                    searchParams.get('dateFrom')
                      ? dayjs(searchParams.get('dateFrom'), 'DD-MM-YYYY').toDate()
                      : null
                  }
                  onChange={handleStartDate}
                  minDate={new Date()}
                  popperClassName="some-custom-class1"
                />
                <span className="ssnFilterDtaeTo">To</span>
                <DatePicker
                  className="fs-4 fw-medium rounded ssnFltrCalenderInp px-4 py-0 border border-light"
                  selected={
                    searchParams.get('dateTo')
                      ? dayjs(searchParams.get('dateTo'), 'DD-MM-YYYY').toDate()
                      : null
                  }
                  onChange={handleEndDate}
                  startDate={dayjs(searchParams.get('dateFrom'), 'DD-MM-YYYY').toDate()}
                  minDate={
                    searchParams.get('dateFrom')
                      ? dayjs(searchParams.get('dateFrom'), 'DD-MM-YYYY').toDate()
                      : new Date()
                  }
                  popperPlacement="top-end"
                  popperClassName="some-custom-class2"
                />
              </div>
            </div>
          )}
          {showSessionType && (
            <div>
              <h2 className="border-bottom text-black fw-medium fs-16 mt-5 mb-4 pb-3">
                Select Session Type
              </h2>
              <div className="alSessnModalCheck">
                <Form.Check
                  type="checkbox"
                  label={'Master Circle'}
                  className="mb-4 gtm_cl_all_session_list_filter_session_type"
                  checked={searchParams.get('showMasterCircle')}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSearchParams((prev) => {
                        prev.set('showMasterCircle', true);
                        return prev;
                      });
                    } else {
                      setSearchParams((prev) => {
                        prev.delete('showMasterCircle');
                        return prev;
                      });
                    }
                  }}
                />
                <Form.Check
                  type="checkbox"
                  label={'Master Cast'}
                  className="mb-4 gtm_cl_all_session_list_filter_master_cast"
                  checked={searchParams.get('showMasterCast')}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSearchParams((prev) => {
                        prev.set('showMasterCast', true);
                        return prev;
                      });
                    } else {
                      setSearchParams((prev) => {
                        prev.delete('showMasterCast');
                        return prev;
                      });
                    }
                  }}
                />
                <Form.Check
                  type="checkbox"
                  label={'Master Consult'}
                  className="mb-4 gtm_cl_all_session_list_filter_master_consult"
                  checked={searchParams.get('showMasterConsult')}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSearchParams((prev) => {
                        prev.set('showMasterConsult', true);
                        return prev;
                      });
                    } else {
                      setSearchParams((prev) => {
                        prev.delete('showMasterConsult');
                        return prev;
                      });
                    }
                  }}
                />
              </div>
            </div>
          )}

          {showVideoFilter ? (
            <div className="rounded filterBarModalSwitch border border-light p-3 mb-4">
              <Form.Check
                className="fs-16 fw-medium position-relative text-start m-0 gtm_cl_medwiki_listing_videos_only"
                type="switch"
                label="Videos Only"
                onChange={(e) => onChangeVideo(e.target.checked)}
                checked={showVideo}
              />
            </div>
          ) : (
            <></>
          )}
          <div>
            <h2 className="border-bottom text-black fw-medium fs-16 mb-4 pb-3">
              Select Specialities
            </h2>
            {!specialitiesLoading &&
              specialities?.length > 0 &&
              specialities?.map((spec, index) => (
                <Form.Check
                  key={spec.master_specialities_id}
                  className="mb-4 gtm_cl_medwiki_listing_filter_specialities"
                  type="checkbox"
                  label={spec.specialities_name}
                  id={spec.master_specialities_id}
                  onChange={() => onChangeTrigger(spec, index)}
                  checked={selectedSpecialities?.includes(spec.master_specialities_id)}
                />
              ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default memo(FilterBar);
